import { useTheme } from '@emotion/react';
import {
  ModalContent,
  ModalContentWrapper,
  ModalTitle,
  ModalTitleWrapper,
} from '../common/Modal';
import { H2 } from '../styled/typography';
import { useModal } from '../../providers/modal';
import CheckMarkSVG from '../../public/img/check-mark.svg';

function SubscribeModal({
  email,
  notSeason,
}: {
  email: string;
  notSeason: boolean;
}) {
  const theme = useTheme();
  const modalState = useModal();
  if (!modalState) {
    return null;
  }
  return (
    <ModalContentWrapper>
      <ModalTitleWrapper setModalState={modalState?.setModalState}>
        <ModalTitle>
          <H2
            css={{
              fontSize: 21,
              color: theme.colors.black,
              lineHeight: '29.4px',
            }}
          >
            Подписка на уведомление
          </H2>
        </ModalTitle>
      </ModalTitleWrapper>
      <ModalContent>
        <div
          css={{
            display: 'flex',
            flexDirection: 'column',
            gap: 7,
          }}
        >
          <H2
            css={{
              color: 'green',
              fontSize: 18,
              lineHeight: '25px',
              marginTop: '0.83em',
              marginBottom: '0.83em',
              flexDirection: 'row',
              display: 'flex',
              alignItems: 'baseline',
              gap: 7,
            }}
          >
            <CheckMarkSVG css={{ width: 16, height: 14 }} /> Подписка оформлена
          </H2>
          {notSeason ? (
            <div>
              Сейчас не сезон, но мы сообщим, когда начнутся продажи билетов! Мы
              отправим Вам письмо на адрес <b>{email}</b>
            </div>
          ) : (
            <div>
              Теперь вы узнаете о поступлении билетов в продажу первым! Мы
              отправим письмо на адрес <b>{email}</b>
            </div>
          )}
        </div>
      </ModalContent>
    </ModalContentWrapper>
  );
}

export default SubscribeModal;
